import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select from "react-select";
import axios from 'axios';
import { toast } from 'react-toastify';

const AddonService = ({ show, onClose, onCreated }) => {

    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [service, setService] = useState('');
    const [unit, setUnit] = useState(null);
    const [cost, setCost] = useState('');
    const [vendor, setVendor] = useState(false);
    const [description, setDescription] = useState('');
    const [errors, setErrors] = useState({});

    const options_units = [
        { value: "1", label: "gms" },
        { value: "2", label: "Kg's" },
        { value: "3", label: "Ltr's" },
        { value: "4", label: "ton's" },
        { value: "5", label: "No's" },
        { value: "6", label: "cm" },
    ];
    
    const validate = () => {
        const newErrors = {};

        if (!service.trim()) newErrors.service = "Service is required.";
        if (!unit) newErrors.unit = "Quantity unit is required.";
        if (!cost || isNaN(cost)) newErrors.cost = "Valid cost per unit is required.";

        return newErrors;
    };

    const handleSubmit = async () => {
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const payload = {
            service,
            quantity: unit.value,
            cost_per_unit: parseFloat(cost),
            vendor: vendor ? 1 : 0,
            description,
            created_by: parseInt(localStorage.getItem("user_id")) || null
        };

        try {
            await axios.post(`${baseURL}/addonservice/add_service`, payload);
            toast.success("Add-on Service created successfully!");
            onClose();
            if (onCreated) onCreated();  
        } catch (error) {
            console.error("Error:", error);
            toast.error("Failed to create service.");
        }
    };

    return (
        <Modal show={show} size="md">
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Create Add-on Service</h3>
                    <Button variant="" type="button" className="close px-6 py-2" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Service<span className="required">*</span></label>
                            <input
                                type="text"
                                className={`form-control ${errors.service ? 'is-invalid' : ''}`}
                                placeholder="Enter Service"
                                value={service}
                                onChange={(e) => setService(e.target.value)}
                            />
                            {errors.service && <div className="text-danger">{errors.service}</div>}
                        </div>

                        <div className='col-lg-12 mb-4'>
                            <label className="text-black font-w500 fs-7">Quantity Unit<span className="required">*</span></label>
                            <Select
                                placeholder="Select Unit"
                                value={unit}
                                onChange={setUnit}
                                options={options_units}
                                className={errors.unit ? 'is-invalid' : ''}
                            />
                            {errors.unit && <div className="text-danger">{errors.unit}</div>}
                        </div>

                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Cost (per Unit)<span className="required">*</span></label>
                            <input
                                type="text"
                                className={`form-control ${errors.cost ? 'is-invalid' : ''}`}
                                placeholder="Enter Cost"
                                value={cost}
                                onChange={(e) => setCost(e.target.value)}
                            />
                            {errors.cost && <div className="text-danger">{errors.cost}</div>}
                        </div>

                        <div className="col-lg-12 mb-4 mt-2">
                            <div className='form-check-inline'>
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    checked={vendor}
                                    onChange={(e) => setVendor(e.target.checked)}
                                />
                                <label className="fs-7 text-black mb-0 font-w500">Vendor</label>
                            </div>
                        </div>

                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Description</label>
                            <textarea
                                rows={4}
                                className="form-control"
                                placeholder="Description"
                                value={description}
                                onChange={(e) => {
                                    let val = e.target.value;
                                    if (val.length > 0) {
                                        val = val.charAt(0).toUpperCase() + val.slice(1);
                                    }
                                    setDescription(val);
                                }}
                            />
                        </div>
                    </div>

                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                        <Link type="submit" className="btn btn-sm btn-primary" onClick={handleSubmit}>
                            Create Add-on Service <i className="fas fa-angle-double-right ms-2"></i>
                        </Link>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default AddonService;
